import { observer } from "@legendapp/state/react";
import { Link2 } from "lucide-react";
import { clipLinkFeedback$ } from "@/state/clipLinkFeedback";

/** In-pane indicator for a clip that was cross-linked to an external source (Legend-driven, local to the document UI). */
export const ClipSourceLinkFeedback = observer(function ClipSourceLinkFeedback() {
  const message = clipLinkFeedback$.message.get();
  if (!message) return null;

  return (
    <div
      className="shrink-0 flex items-center gap-2 rounded-md border border-emerald-500/40 bg-emerald-500/10 px-3 py-2 text-sm text-emerald-800 dark:text-emerald-100"
      role="status"
      data-testid="clip-source-link-feedback"
    >
      <Link2 className="h-4 w-4 shrink-0 opacity-80" aria-hidden />
      <span className="font-medium">{message}</span>
    </div>
  );
});
